// @flow
import React, { PureComponent } from 'react';
import renderHTML from 'react-render-html';

import { S } from '../../pages/Docs';
import type { Guide as Props } from '../../reducers/version';

class Guide extends PureComponent<Props, Props, void> {
  static defaultProps = {
    slug: '',
    title: '',
    content: ''
  };

  render() {
    const {
      props: {
        title,
        content
      }
    } = this;

    return (
      <div>
        <div className={`pb3 ${S.borderBottom}`}>
          <h2 className="mt0 mb1">
            {title}
          </h2>
        </div>
        <div className="description">
          {renderHTML(content)}
        </div>
      </div>
    );
  }
}

export default Guide;



// WEBPACK FOOTER //
// ./src/components/Guide/index.jsx